import { handlePhoneClick } from '../../../utils/trackPhoneCall';
import { siteConfig } from '../../../config/site';

interface Step {
  icon: string;
  title: string;
  description: string;
}

interface HowItWorksProps {
  steps?: Step[];
}

const HowItWorks = ({ steps: customSteps }: HowItWorksProps) => {
  const defaultSteps = [
    {
      icon: 'ri-file-text-line',
      title: 'Preencher Formulário',
      description: 'Complete o formulário com os seus dados e tipo de serviço necessário'
    },
    {
      icon: 'ri-phone-line',
      title: 'Técnico Contacta',
      description: 'Um técnico da sua zona entra em contacto para agendar a visita'
    },
    {
      icon: 'ri-calculator-line',
      title: 'Orçamento Gratuito',
      description: 'Recebe um orçamento detalhado e transparente sem qualquer custo'
    },
    {
      icon: 'ri-tools-line',
      title: 'Serviço no Local',
      description: 'Realizamos o serviço com qualidade e garantia na sua casa'
    }
  ];

  const steps = customSteps || defaultSteps;

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Como Funciona
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {siteConfig.domain === 'alphaclean.pt'
              ? 'Processo simples e transparente, com equipas fixas e valor fechado'
              : siteConfig.domain === 'alphaclimatizacao.pt'
              ? 'Processo simples e transparente, do primeiro contacto à colocação em serviço'
              : 'Processo simples e rápido para resolver os seus problemas com canalização'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                  <span className="text-blue-600 font-bold text-sm">{index + 1}</span>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={`tel:${siteConfig.phone}`}
            onClick={handlePhoneClick}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-8 rounded-lg transition-colors duration-200 whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-phone-line"></i>
            Começar Agora
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
